export const IMAGES = {
  WALLET_IMAGES: {
    metamask: "assets/images/walletImages/MetaMask_Fox.svg",
    walletConnect: "assets/images/walletImages/walletconnect-seeklogo.svg",
  },
};
